import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import moment from "moment";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import SelectDropdown from "../../components-react/SelectDropdown";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import {
  fetchAllAddonsByGymData,
  fetchAllAddonSessionsData,
  fetchUserDetailsByMobileData,
} from "../../../redux/reducers/apiSlice";
import Loader from "../../ui/Loader";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../../data/APIs";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { add_new_pt_prospect } from "../../../data/ApiEndpoints";
import { getMaxDateUptoLastMonthDate } from "../../common-data/Converts";

const validateForm = (formValues) => {
  let errors = {};

  if (!formValues.selectedAddon) {
    errors.selectedAddon = "PT Addon Is Required!";
  }

  if (!formValues.selectedSession) {
    errors.selectedSession = "PT Sessions Is Required!";
  }

  if (!formValues.selectedPrice) {
    errors.selectedPrice = "Expected Closure Value Is Required!";
  }

  const maxDate = getMaxDateUptoLastMonthDate().startOf("day");
  const selectedDate = moment
    .tz(formValues.expectedClosureDate, "Asia/Kolkata")
    .startOf("day");

  if (!formValues.expectedClosureDate) {
    errors.expectedClosureDate = "Expected Closure Date is required!";
  } else if (
    selectedDate.isAfter(maxDate) ||
    selectedDate.isBefore(moment.tz("Asia/Kolkata").startOf("day"))
  ) {
    errors.expectedClosureDate = `Select a date within the allowed range: Today to ${maxDate.format(
      "YYYY-MM-DD"
    )}.`;
  }

  return errors;
};

const PTProspectForm = ({ closeModal, callFunction, userInfoData, isEdit }) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const { loading, userDetailsByMobile, allAddonsByGymData, allAddonSessions } =
    useSelector((state) => state.api);
  const gymData = useSelector(selectGymData);

  const initialAddonsData = {
    allAddonsData: [],
    allAddonsDropdownData: [],
    allSessionsData: [],
    allSessionsDropdownData: [],
    selectedAddonSessionInfo: [],
  };
  const [allAddons, setAllAddons] = useState(initialAddonsData);
  const [selectedPlanAllPrice, setSelectedPlanAllPrice] = useState([]);
  const [selectedSessionPla, setSelectedSessionPlan] = useState([]);

  const iniFormValues = {
    trainerName: userInfoData?.name || "",
    trainerMobile: userInfoData?.mobile || "",
    trainerEmail: userInfoData?.email || "",
    selectedGym:
      userInfoData?.gym_name && userInfoData?.gym_id
        ? {
            label: userInfoData.gym_name,
            value: userInfoData.gym_id,
          }
        : "",
    memberName: "",
    memberMobile: "",
    memberEmail: "",
    selectedAddon: "",
    selectedSession: "",
    selectedPlanIndex: "",
    selectedPrice: "",
    expectedClosureDate: "",
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const [isFetchUser, setIsFetchUser] = useState(false);
  const [memberFetchedData, setMemberFetchedData] = useState(null);
  const iniMemStatus = {
    isShowForm: false,
    errorMessage: "",
  };
  const [memberStatus, setMemberStatus] = useState(iniMemStatus);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    setIsSubmit(false);

    if (name === "memberMobile") {
      const mobileValue = e.target.value;

      if (mobileValue.length <= 10) {
        setFormValues((prevs) => ({
          ...prevs,
          [name]: value,
        }));
        setIsFetchUser(false);
        setMemberFetchedData(null);
        setMemberStatus(iniMemStatus);
      }
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: type === "checkbox" ? checked : type === "file" ? file : value,
      }));
    }
  };

  const onChangeDropdown = (value, name) => {
    if (name === "selectedAddon") {
      setFormValues({
        ...formValues,
        selectedSession: "",
        selectedPlanIndex: "",
        selectedPrice: "",
        [name]: value,
      });
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  function getMemberDetails() {
    dispatch(
      fetchUserDetailsByMobileData({
        userMobile: formValues.memberMobile,
        token: userInfoData?.token,
      })
    );
  }

  function getAddonDetails() {
    const gymId = formValues.selectedGym?.value || "";

    dispatch(
      fetchAllAddonsByGymData({
        gymId: gymId,
        isPT: 1,
        token: userInfoData?.token,
      })
    );
  }

  function getSessionDetails() {
    const addonId = formValues.selectedAddon?.value || "";

    dispatch(
      fetchAllAddonSessionsData({
        addonId: addonId,
        token: userInfoData?.token,
      })
    );
  }

  const handleSelectPlan = (index, amount, planId) => {
    if (index === formValues.selectedPlanIndex) {
      setFormValues({
        ...formValues,
        selectedPlanIndex: "",
        selectedPrice: {
          value: "",
          label: "",
        },
      });
    } else {
      setFormValues({
        ...formValues,
        selectedPlanIndex: index,
        selectedPrice: {
          value: planId,
          label: amount,
        },
      });
    }
  };

  function onClickFetchUserDetails(e) {
    e.preventDefault();

    setIsSubmit(false);

    if (formValues.memberMobile) {
      setIsFetchUser(true);
      getMemberDetails();
    } else {
      toast.error("Enter Mobile Number");
    }
  }

  function onClearNumber(e) {
    e && e.preventDefault();

    const handleConfirm = () => {
      setFormValues((prevs) => ({
        ...prevs,
        memberMobile: "",
      }));
      setFormValues((prevs) => ({
        ...prevs,
        selectedGym: prevs.selectedGym,
      }));
      setIsSubmit(false);
      setIsFetchUser(false);
      setMemberFetchedData(null);
    };

    showConfirmAlert(handleConfirm, `You want to clear the form?`);
  }

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = add_new_pt_prospect;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(iniFormValues);
        setIsFetchUser(false);
        setMemberFetchedData(null);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage =
          result?.payload?.data ||
          result?.payload?.message ||
          result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    setFormValues((prevs) => ({
      ...prevs,
      trainerName: userInfoData?.name || "",
      trainerMobile: userInfoData?.mobile || "",
      trainerEmail: userInfoData?.email || "",
      selectedGym:
        userInfoData?.gym_name && userInfoData?.gym_id
          ? {
              label: userInfoData?.gym_name,
              value: userInfoData?.gym_id,
            }
          : "",
    }));
  }, []);

  useEffect(() => {
    // if (!formValues.selectedGym?.value) {
    dispatch(fetchGymData(userInfoData?.token));
    // }
  }, [formValues.selectedGym]);

  // useEffect(() => {
  //   if (isFetchUser && !formErrors.memberMobile) {
  //     getMemberDetails();
  //   }
  // }, [isFetchUser, formErrors.memberMobile]);

  useEffect(() => {
    if (
      isFetchUser &&
      !loading &&
      !formErrors.memberMobile &&
      userDetailsByMobile?.status &&
      userDetailsByMobile?.data?.length > 0
    ) {
      const memberData = userDetailsByMobile.data[0];
      setMemberFetchedData(memberData);
    } else if (
      isFetchUser &&
      !loading &&
      !formErrors.memberMobile &&
      !userDetailsByMobile?.status
    ) {
      userDetailsByMobile?.message && toast.error(userDetailsByMobile?.message);
      setMemberFetchedData(null);
      setIsFetchUser(false);
      return;
    } else {
      setMemberFetchedData(null);
      return;
    }
  }, [isFetchUser, loading, userDetailsByMobile, formErrors.memberMobile]);

  useEffect(() => {
    if (memberFetchedData) {
      setFormValues((prevs) => ({
        ...prevs,
        memberName: memberFetchedData?.name || "",
        memberEmail: memberFetchedData?.email || "",
      }));
    }
  }, [memberFetchedData]);

  useEffect(() => {
    if (memberFetchedData && !loading) {
      const memberName = memberFetchedData?.name || "Member";
      // const memberStatus = memberFetchedData?.status || "";
      const memberStatus = memberFetchedData?.current_subscription_status || "";
      const memberGymId = memberFetchedData?.gym_id || "";
      const memberGymName = memberFetchedData?.gym_name || "";
      const memberAcountType = memberFetchedData?.account_type || "";

      if (memberStatus !== "active") {
        setMemberStatus({
          isShowForm: false,
          errorMessage: `${memberName} Do Not Have Active Subscription`,
        });
      } else if (
        memberStatus === "active" &&
        memberGymId !== userInfoData?.gym_id
      ) {
        setMemberStatus({
          isShowForm: false,
          errorMessage: `${
            memberFetchedData?.name || "Member"
          } Has Active Subscription In Gym ${
            memberFetchedData?.gym_name || ""
          }`,
        });
      } else if (memberGymId !== userInfoData?.gym_id) {
        const handleConfirm = () => {
          setMemberStatus({
            isShowForm: true,
            errorMessage: "",
          });
        };

        showConfirmAlert(
          handleConfirm,
          `${memberName} Is Belongs To ${memberGymName} Gym. Do You Want To Change Gym With ${userInfoData?.gym_name} Gym?`,
          "No, Cancel Submission",
          "Yes, Proceed"
        );
        // setMemberStatus({
        //   isShowForm: false,
        //   errorMessage: `${
        //     memberFetchedData?.name || "Member"
        //   } Belongs To Different Gym ${memberFetchedData?.gym_name || ""}`,
        // });
      } else if (memberAcountType !== "member") {
        setMemberStatus({
          isShowForm: false,
          errorMessage: `Enterered ${
            memberName || "Number"
          }'s account type - ${memberAcountType} `,
        });
      } else {
        setMemberStatus({
          isShowForm: true,
          errorMessage: "",
        });
      }
    } else {
      setMemberStatus(iniMemStatus);
    }
  }, [memberFetchedData, loading]);

  useEffect(() => {
    if (formValues.selectedGym) {
      getAddonDetails();
    }
  }, [formValues.selectedGym]);

  useEffect(() => {
    if (allAddonsByGymData?.status && allAddonsByGymData?.data?.length > 0) {
      const allAddonsDropdownDataFind = allAddonsByGymData.data.map((addon) => {
        return {
          label: `${addon.name} / ${addon?.is_pt === "1" ? "PT" : "Not PT"}`,
          value: addon.uid,
        };
      });
      setAllAddons({
        ...allAddons,
        allAddonsData: allAddonsByGymData.data,
        allAddonsDropdownData: allAddonsDropdownDataFind,
      });
    } else {
      setAllAddons((prevs) => ({
        ...prevs,
        allAddonsData: [],
        allAddonsDropdownData: [],
      }));
    }
  }, [allAddonsByGymData]);

  useEffect(() => {
    if (formValues.selectedAddon?.value) {
      getSessionDetails();
    }
  }, [formValues.selectedAddon]);

  useEffect(() => {
    if (allAddonSessions?.status && allAddonSessions?.data?.length > 0) {
      const allAddonsSessionsDropdownDataFind = allAddonSessions.data.map(
        (addon) => {
          return {
            label:
              `${addon?.n_session} Sessions for ${addon?.duration} Day(s)` ||
              "",
            value: addon?.uid || "",
            info: addon,
          };
        }
      );

      setAllAddons({
        ...allAddons,
        allSessionsData: allAddonSessions.data,
        allSessionsDropdownData: allAddonsSessionsDropdownDataFind,
      });
    } else {
      setAllAddons({
        ...allAddons,
        allSessionsData: [],
        allSessionsDropdownData: [],
      });
    }
  }, [allAddonSessions]);

  useEffect(() => {
    if (formValues.selectedSession?.value) {
      const priceDetailsArray = allAddonSessions?.data?.filter(
        (addon) => addon?.uid === formValues.selectedSession?.value
      );

      setSelectedSessionPlan(priceDetailsArray);

      if (priceDetailsArray?.[0]?.price_details?.length > 0) {
        setSelectedPlanAllPrice(priceDetailsArray?.[0]?.price_details);
      } else {
        setSelectedPlanAllPrice([]);
        formValues({
          ...formValues,
          selectedPlanIndex: "",
        });
      }
    } else {
      setSelectedPlanAllPrice([]);
    }
  }, [formValues.selectedPlanType, formValues.selectedSession]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const trainerId = userInfoData?.user_id || "";
      const gymId = formValues.selectedGym?.value || userInfoData?.gym_id || "";
      const memberId = memberFetchedData?.uid || "";

      const userData = {
        trainer_id: trainerId,
        added_by: trainerId,
        gym_id: gymId,
        user_id: memberId,
        status: "active",
        prospect_value: formValues.selectedPrice?.label || "",
        expected_session: formValues.selectedSession?.info?.n_session || "",
        addon_id: formValues.selectedAddon?.value || "",
        expected_closure_date: formValues.expectedClosureDate || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  // console.log("formValues=> ", formValues);

  return (
    <div className="form-container open-form-page-container">
      <CommonHeadingNBtns
        title={`Add New PT Prospect`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
        isDisabled={!memberStatus.isShowForm}
      />
      <form
        className="formContainer"
        style={{
          marginTop: "30px",
        }}>
        <div className="formInputsGrid fourGridSystem">
          <div className="formInputBox">
            <label htmlFor="trainerName" className={`formInputLabel`}>
              trainer Name
            </label>

            <input
              type="text"
              placeholder="Trainer Full Name"
              className={`formInput`}
              name="trainerName"
              value={formValues.trainerName}
              disabled
            />

            <span className="error-label">{formErrors?.trainerName || ""}</span>
          </div>

          <div className="formInputBox">
            <label htmlFor="trainerMobile" className={`formInputLabel`}>
              trainer mobile
            </label>

            <input
              type="number"
              placeholder="Trainer Mobile Number"
              className={`formInput`}
              name="trainerMobile"
              value={formValues.trainerMobile}
              disabled
            />

            <span className="error-label">
              {formErrors?.trainerMobile || ""}
            </span>
          </div>

          <div className="formInputBox">
            <label htmlFor="trainerEmail" className={`formInputLabel`}>
              trainer email
            </label>

            <input
              type="email"
              placeholder="Trainer Email"
              className={`formInput`}
              name="trainerEmail"
              value={formValues.trainerEmail}
              disabled
            />

            <span className="error-label">
              {formErrors?.trainerEmail || ""}
            </span>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedGym" className={`formInputLabel`}>
              gym name
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedGym ? "formError" : ""
              }`}
              style={{
                border:
                  userInfoData?.gym_name && userInfoData?.gym_id
                    ? "none"
                    : "1px solid #c2c2c2",
              }}>
              <SelectDropdown
                options={gymData?.length > 0 ? gymData : []}
                selectedOption={formValues.selectedGym}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedGym")
                }
                name="Gym"
                isDisable={userInfoData?.gym_name && userInfoData?.gym_id}
                // isDisable={formValues.selectedGym?.value}
                // preventKeyboardOpen={true}
              />
            </div>
          </div>
        </div>

        {formValues.selectedGym && (
          <div className="formInputsGrid twoGridSystem input-with-btn">
            <div className="formInputBox">
              <label htmlFor="memberMobile" className={`formInputLabel`}>
                member mobile <span className="required">*</span>
              </label>

              <input
                type="number"
                placeholder="Enter Member Mobile Number"
                className={`formInput ${
                  formErrors?.memberMobile ? "formError" : ""
                }`}
                name="memberMobile"
                value={formValues.memberMobile}
                onChange={onChangeInput}
              />

              <span className="error-label">
                {formErrors?.memberMobile || ""}
              </span>

              {!memberStatus.isShowForm && memberStatus.errorMessage && (
                <span className="info">{memberStatus.errorMessage || ""}</span>
              )}
            </div>

            <div className="formInputButtons">
              <Button
                className="saveBtn"
                variant="danger"
                onClick={onClickFetchUserDetails}
                disabled={memberFetchedData || formErrors.memberMobile}>
                {loading ? <Loader /> : "Fetch Member Details"}
              </Button>
              {!loading && (
                <Button
                  className="cancelBtn"
                  variant="dark"
                  onClick={onClearNumber}>
                  Clear
                </Button>
              )}
            </div>
          </div>
        )}

        {memberStatus.isShowForm && (
          <>
            <div className="formInputsGrid fourGridSystem">
              <div className="formInputBox">
                <label htmlFor="memberName" className={`formInputLabel`}>
                  member Name
                </label>

                <input
                  type="text"
                  placeholder="Member Full Name"
                  className={`formInput`}
                  name="memberName"
                  value={formValues.memberName}
                  disabled
                />

                <span className="error-label">
                  {formErrors?.memberName || ""}
                </span>
              </div>

              <div className="formInputBox">
                <label htmlFor="memberEmail" className={`formInputLabel`}>
                  member email
                </label>

                <input
                  type="email"
                  placeholder="Member Email"
                  className={`formInput`}
                  name="memberEmail"
                  value={formValues.memberEmail}
                  disabled
                />

                <span className="error-label">
                  {formErrors?.memberEmail || ""}
                </span>
              </div>

              <div className="formInputBox">
                <label htmlFor="selectedAddon" className="formInputLabel">
                  Select Addon <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedAddon ? "formError" : ""
                  }`}>
                  <SelectDropdown
                    options={allAddons.allAddonsDropdownData}
                    selectedOption={formValues.selectedAddon}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(selectedValue, "selectedAddon")
                    }
                    name="selectedAddon"
                  />
                </div>
              </div>

              {formValues.selectedAddon && (
                <div className="formInputBox">
                  <label htmlFor="selectedSession" className="formInputLabel">
                    Select session <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper ${
                      formErrors.selectedSession ? "formError" : ""
                    }`}>
                    <SelectDropdown
                      options={allAddons.allSessionsDropdownData}
                      selectedOption={formValues.selectedSession}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown(selectedValue, "selectedSession")
                      }
                      name="selectedSession"
                    />
                  </div>
                </div>
              )}

              {selectedPlanAllPrice?.length > 0 ? (
                <div className="flexWrapMultiBoxontainer span2">
                  <div className="formInputBox">
                    <label htmlFor="selectedPrice" className="formInputLabel">
                      Expected Closure Amount{" "}
                      <span className="required">*</span>
                    </label>

                    <div
                      className={`flexWrapMultiBoxontainerSub ${
                        formErrors.selectedPrice ? "formError" : ""
                      }`}
                      style={{
                        background: "#fff",
                        border: "1px solid #c2c2c2",
                        boxShadow: "none",
                      }}>
                      {selectedPlanAllPrice?.map((price, index) => (
                        <div
                          className={`wrappedBox ${
                            formValues.selectedPlanIndex === index
                              ? "selected"
                              : ""
                          }`}
                          key={index}
                          onClick={() =>
                            handleSelectPlan(
                              index,
                              price?.plan_price,
                              price?.plan_uid
                            )
                          }>
                          <span
                            className="wappedValueLabel"
                            style={{
                              fontSize: "25px",
                              cursor: "pointer",
                              padding: "10px 20px",
                            }}>
                            ₹{price?.plan_price || 0}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : formValues.selectedSession ? (
                <span className="errorMessage">Price Not Available</span>
              ) : null}

              <div className="formInputBox">
                <label htmlFor="expectedClosureDate" className="formInputLabel">
                  Expected closure date <span className="required">*</span>
                </label>

                <input
                  type="date"
                  min={moment.tz("Asia/Kolkata").format("YYYY-MM-DD")}
                  max={getMaxDateUptoLastMonthDate().format("YYYY-MM-DD")}
                  className={`formInput ${
                    formErrors.expectedClosureDate ? "formError" : ""
                  } ${formValues.expectedClosureDate ? "date-has-value" : ""}`}
                  name="expectedClosureDate"
                  value={formValues.expectedClosureDate}
                  onChange={(e) => onChangeInput(e)}
                />

                {formErrors?.expectedClosureDate && (
                  <span className="info">
                    {formErrors.expectedClosureDate || ""}
                  </span>
                )}

                {/* <input
                  type="date"
                  min={new Date().toISOString().split("T")[0]}
                  max={
                    new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
                      .toISOString()
                      .split("T")[0]
                  }
                  className={`formInput ${
                    formErrors.expectedClosureDate ? "formError" : ""
                  } ${formValues.expectedClosureDate ? "date-has-value" : ""}`}
                  name="expectedClosureDate"
                  value={formValues.expectedClosureDate}
                  onChange={(e) => {
                    const minDate = new Date(
                      new Date().toISOString().split("T")[0]
                    );
                    const maxDate = new Date(
                      Date.now() + 7 * 24 * 60 * 60 * 1000
                    );
                    const selectedDate = new Date(e.target.value);

                    if (selectedDate >= minDate && selectedDate <= maxDate) {
                      onChangeInput(e);
                    } else {
                      e.target.value = "";
                      alert(
                        `Please select a date within the allowed range: ${minDate.toLocaleDateString()} to ${maxDate.toLocaleDateString()}.`
                      );
                    }
                  }}
                /> */}
              </div>
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default PTProspectForm;
